import { Grid, TextInput } from '@ts/storybook';
import { IForm } from '@ts/ui-models';

interface ICategoryFormProps extends IForm {}
const CategoryForm = (props: ICategoryFormProps) => {
  const { values, mode, requiredFields, onCallbackChange } = props;
  const isViewMode = mode === 'view';

  //#region Handlers
  //#endregion

  return (
    <Grid id="category-form" container size={{ xs: 12, md: 6 }}>
      <TextInput
        isReadOnly={isViewMode}
        label="Name"
        value={values.name}
        onChangeValue={onCallbackChange('name')}
        required={requiredFields.includes('name')}
        infoText="Blank spaces at the beggining and the end will be trimmed on save"
      />
    </Grid>
  );
};

export default CategoryForm;
